import { ReactNode } from "react";
import ModalComponent from "..";
import { ModalCompProps } from "../../../utils/types";

export const EventMoreOptionsModal = ({
  open,
  handleClose,
  options,
}: ModalCompProps & {
  options: {
    name: ReactNode;
    value?: string;
    onClick?: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  }[];
}) => {
  return (
    <ModalComponent
      open={open}
      handleClose={handleClose}
      className="!bg-grey-50 !p-[20px]"
      dialogClassName="!my-0"
      showHeader={false}
      mobileAnchorBottom
      closeOnOverlayClick
    >
      <div className="flex flex-col gap-1">
        {options.map((option, idx) => {
          const key = `${idx}-moreOptions`;

          return (
            <button
              key={key}
              type="button"
              onClick={() => {
                if (option.onClick) {
                  option.onClick();
                }
                handleClose();
              }}
              className={`flex items-center gap-1 border-b border-grey-100 p-3 font-bold last:border-b-0`}
            >
              {option.name}
            </button>
          );
        })}
      </div>
    </ModalComponent>
  );
};
